"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputMaxLength = exports.getInputTagType = exports.formatInput = exports.InputTagType = exports.InputType = void 0;
const utils_1 = require("../utils");
var InputType;
(function (InputType) {
    InputType[InputType["DATE"] = 0] = "DATE";
    InputType[InputType["EMAIL"] = 1] = "EMAIL";
    InputType[InputType["FLOAT"] = 2] = "FLOAT";
    InputType[InputType["INTEGER"] = 3] = "INTEGER";
    InputType[InputType["LICENSE_PLATE"] = 4] = "LICENSE_PLATE";
    InputType[InputType["ORGANIZATION_NUMBER"] = 5] = "ORGANIZATION_NUMBER";
    InputType[InputType["PERSONAL_IDENTITY_NUMBER"] = 6] = "PERSONAL_IDENTITY_NUMBER";
    InputType[InputType["PHONE_NUMBER"] = 7] = "PHONE_NUMBER";
    InputType[InputType["TEXT_AREA"] = 8] = "TEXT_AREA";
    InputType[InputType["TEXT_LINE"] = 9] = "TEXT_LINE";
    InputType[InputType["TIME"] = 10] = "TIME";
    InputType[InputType["ZIP_CODE"] = 11] = "ZIP_CODE";
    InputType[InputType["MONTH"] = 12] = "MONTH";
})(InputType = exports.InputType || (exports.InputType = {}));
/**
 * This holds all available types for the HTML Input tag.
 * Cf. https://developer.mozilla.org/en-us/docs/Web/HTML/Element/input#input_types
 *
 * Only the types in use by us are assigned a textual value.
 * The rest are kept in sync with the enum's default numerical value.
 */
var InputTagType;
(function (InputTagType) {
    InputTagType[InputTagType["button"] = 0] = "button";
    InputTagType[InputTagType["checkbox"] = 1] = "checkbox";
    InputTagType[InputTagType["color"] = 2] = "color";
    InputTagType["date"] = "date";
    InputTagType[InputTagType["datetime-local"] = 4] = "datetime-local";
    InputTagType["email"] = "email";
    InputTagType[InputTagType["file"] = 6] = "file";
    InputTagType[InputTagType["hidden"] = 7] = "hidden";
    InputTagType[InputTagType["image"] = 8] = "image";
    InputTagType["month"] = "month";
    InputTagType[InputTagType["number"] = 10] = "number";
    InputTagType[InputTagType["password"] = 11] = "password";
    InputTagType[InputTagType["radio"] = 12] = "radio";
    InputTagType[InputTagType["range"] = 13] = "range";
    InputTagType[InputTagType["reset"] = 14] = "reset";
    InputTagType[InputTagType["search"] = 15] = "search";
    InputTagType[InputTagType["submit"] = 16] = "submit";
    InputTagType["tel"] = "tel";
    InputTagType["text"] = "text";
    InputTagType["time"] = "time";
    InputTagType[InputTagType["url"] = 20] = "url";
    InputTagType[InputTagType["week"] = 21] = "week";
})(InputTagType = exports.InputTagType || (exports.InputTagType = {}));
/**
 * Transform the value in the input field into the expected format.
 * Returns the formatted string, and the parsed input.
 */
const formatInput = (value, type, decimals) => {
    switch (+type) {
        case InputType.EMAIL:
            return (0, utils_1.formatEmailInput)(value);
        case InputType.FLOAT:
            return (0, utils_1.formatNumberInput)(value, type, decimals);
        case InputType.INTEGER:
            return (0, utils_1.formatNumberInput)(value, type);
        case InputType.LICENSE_PLATE:
            return (0, utils_1.formatLicensePlateInput)(value);
        case InputType.ORGANIZATION_NUMBER:
            return (0, utils_1.formatOrganizationNumberInput)(value);
        case InputType.PERSONAL_IDENTITY_NUMBER:
            return (0, utils_1.formatPersonalIdentityNumber)(value);
        case InputType.PHONE_NUMBER:
            return (0, utils_1.formatPhoneNumberInput)(value);
        case InputType.ZIP_CODE:
            return (0, utils_1.formatZipCode)(value);
        case InputType.DATE: // Chrome includes a date picker for type="date"
        case InputType.TEXT_AREA:
        case InputType.TEXT_LINE:
        case InputType.TIME: // Chrome includes a time picker for type="time"
        case InputType.MONTH:
        default:
            return { formatted: value, parsed: value };
    }
};
exports.formatInput = formatInput;
/**
 * What value should the input tag's `type` property have?
 * This determines what keyboard is shown on mobile devices.
 */
const getInputTagType = (type) => {
    switch (+type) {
        case InputType.DATE:
            return InputTagType.date;
        case InputType.EMAIL:
            return InputTagType.email;
        case InputType.INTEGER:
        case InputType.ORGANIZATION_NUMBER:
        case InputType.PERSONAL_IDENTITY_NUMBER:
        case InputType.PHONE_NUMBER:
        case InputType.ZIP_CODE:
            return InputTagType.tel;
        case InputType.TIME:
            return InputTagType.time;
        case InputType.MONTH:
            return InputTagType.month;
        case InputType.FLOAT:
        case InputType.LICENSE_PLATE:
        case InputType.TEXT_AREA:
        case InputType.TEXT_LINE:
        default:
            return InputTagType.text;
    }
};
exports.getInputTagType = getInputTagType;
/**
 * Some InputType values specify a value max length.
 */
const getInputMaxLength = (type) => {
    switch (+type) {
        case InputType.FLOAT:
        case InputType.INTEGER:
            // Somehow starts giving rounding errors when going past this length.
            // Should not affect real-world usage, unless we need to enter values
            // above 10 quadrillion.
            return 16;
        case InputType.LICENSE_PLATE:
            // License plate length + 1 space separator
            return 7 + 1;
        case InputType.PERSONAL_IDENTITY_NUMBER:
            // Personal number length + 1 space separator
            return 11 + 1;
        case InputType.ORGANIZATION_NUMBER:
            // Organization number length + 2 space separators
            return 9 + 2;
        case InputType.PHONE_NUMBER:
            // Norwegian phone number length + 3 space separators
            return 8 + 3;
        case InputType.ZIP_CODE:
            // Norwegian zip code length
            return 4;
        case InputType.DATE:
        case InputType.EMAIL:
        case InputType.TEXT_AREA:
        case InputType.TEXT_LINE:
        case InputType.TIME:
        default:
            return null;
    }
};
exports.getInputMaxLength = getInputMaxLength;
//# sourceMappingURL=input-format.js.map